import { Component, OnInit } from '@angular/core';
import { ResumeService } from '../../dashboard/services/resume.service';
import { UserService } from 'src/app/core/services/user.service';
import { AlertService } from '../../case-new-view/alert.service';

@Component({
  selector: 'dashboard-alerts',
  templateUrl: './dashboard-alerts.component.html',
  styleUrls: ['./dashboard-alerts.component.scss'],
})
export class DashboardAlertsComponent implements OnInit {
  constructor(
    private resumeService: ResumeService,
    private userService: UserService,
    private alertService: AlertService
  ) {}

  ngOnInit() {
    this.resumeService.processData({
      cases: '',
      units: '',
      user: [
        this.userService.currentUser.role.seeCases,
        this.userService.currentUser._id,
      ].join(';'),
    });
    this.alertService.toHeaderInfo.next({
      information: `Dashboard`,
    });
  }
}
